import lb from '@/lib/loopback';


export function findEstados(settings = {}) {
  return lb
    .find('/EstadoConservacao/', settings);
}

export default {
  findEstados,
};
